import React, { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library';

const ScannerComponent = ({ onResult }) => {
  const webcamRef = useRef(null);
  const [isScanning, setIsScanning] = useState(true);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();

    const scan = async () => {
      if (
        webcamRef.current &&
        webcamRef.current.video &&
        webcamRef.current.video.readyState === 4
      ) {
        try {
          const result = await codeReader.decodeFromVideoElement(webcamRef.current.video);
          if (result && result.getText()) {
            console.log('Código detectado:', result.getText());
            onResult(result.getText());
            setIsScanning(false); // para leitura após 1 código
          }
        } catch (err) {
          if (!(err instanceof NotFoundException)) {
            console.warn('Erro de leitura:', err.message);
          }
        }
      }

      if (isScanning) {
        requestAnimationFrame(scan);
      }
    };

    if (isScanning) {
      requestAnimationFrame(scan);
    }

    return () => {
      setIsScanning(false);
    };
  }, [isScanning, onResult]);

  return (
    <div style={{ textAlign: 'center', width: '95vw' }}>


<Webcam
  ref={webcamRef}
  audio={false}
  screenshotFormat="image/jpeg"
  videoConstraints={{ facingMode: 'environment' }}
  style={{
    width: 'calc(100%)',
    height: '160px',
    borderRadius: '8px',
    objectFit: 'cover',
    backgroundColor: '#000',
  }}
/>


    </div>
  );
};

export default ScannerComponent;
